interface LightboxConfig {
	// type: string; // image, video, inline (not currently used)
	target: string; // Image/video source or element class
	heading?: string;
	triggerClass?: string;
	onOpen?: Function;
	onFirstOpen?: Function;
}
export default class Lightbox {
	// private type: string;
	public el: HTMLElement;
	private target: string;
	private heading: string;
	private triggerEl: HTMLCollection;
	private onOpen: Function;
	private onFirstOpen: Function;
	private isFirstOpen: boolean = true;

	private lightboxTemplateEl: HTMLElement;

	constructor(lightboxConfig: LightboxConfig) {
		// this.type = lightboxConfig.type;
		this.target = lightboxConfig.target;
		this.heading = lightboxConfig.heading;
		this.triggerEl = document.getElementsByClassName(lightboxConfig.triggerClass);
		this.onOpen = lightboxConfig.onOpen;
		this.onFirstOpen = lightboxConfig.onFirstOpen;

		this.lightboxTemplateEl = this.buildLightbox();

		if (this.triggerEl) {
			for (let index: number = 0; index < this.triggerEl.length; index++) {
				const element: Element = this.triggerEl[index];
				element.addEventListener('click', this.openCB);
			}
		}
	}

	private buildLightbox(): HTMLElement {
		const targetEl: Node = document.getElementsByClassName(this.target)[0].cloneNode(true);
		if (!targetEl)
			return;

		const lightboxEl: HTMLElement = document.createElement('div');
		lightboxEl.classList.add('lightbox');

		lightboxEl.innerHTML =
			`<div class="lightbox__overlay"></div>
			<div class="lightbox__inner">
				<div class="lightbox__header">
					${this.heading ? `<h2 class="lightbox__heading">${this.heading}</h2>` : ''}
					<i class="lightbox--close icon-close"></i>
				</div>
				<div class="lightbox__content"></div>
			</div>`;

		const lightboxCloseEl: Element = lightboxEl.getElementsByClassName('icon-close')[0];
		lightboxCloseEl.addEventListener('click', this.closeCB);

		const lightboxOverlayEl: Element = lightboxEl.getElementsByClassName('lightbox__overlay')[0];
		lightboxOverlayEl.addEventListener('click', this.closeCB);

		const lightboxContentEl: Element = lightboxEl.getElementsByClassName('lightbox__content')[0];
		lightboxContentEl.appendChild(targetEl);

		return lightboxEl;
	}

	public open(): void {
		document.body.classList.add('lightbox--open');
		this.el = document.body.insertBefore(this.lightboxTemplateEl, document.body.children[0]);

		if (this.onOpen) {
			if (this.isFirstOpen && this.onFirstOpen) {
				this.onFirstOpen();
				this.isFirstOpen = false;
			}
			this.onOpen();
		}
	}

	public openCB = (): void => {
		this.open();
	}

	public close(): void {
		document.body.classList.remove('lightbox--open');
		document.body.removeChild(this.el);
	}

	public closeCB = (event: Event): void => {
		this.close();
	}
}